export enum WordType {
  LUCY_ERROR = 'LUCY_ERROR',
  LUCY_WARN = 'LUCY_WARN',
  LUCY_INFO = 'LUCY_INFO',
}
